export const EXERCISE_DEFAULTS = {
  set: 3,
  repeat: 12,
  tolerance: 5,
  days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
}

export const mappedDays: Record<string, string> = {
  "Mon": "Monday",
  "Tue": "Tuesday",
  "Wed": "Wednesday",
  "Thu": "Thursday",
  "Fri": "Friday",
  "Sat": "Saturday",
  "Sun": "Sunday"
}

export const SELECTBUTTON_OPTIONS = [
  { name: "panels", value: true },
  { name: "wizard", value: false }
]